import(/* webpackMode: "eager", webpackExports: ["NoSSRAdminApp"] */ "/builds/atbdigitalteam/growlabs/software/grow-frontend/admin/src/NoSSRAdminApp.tsx");
